import PropTypes from "prop-types"
import styled from "styled-components"
import Div from "./div"
import { cssConfig } from "@utils/css-validator"
import media from "../../styles/media"

const Flex = styled(Div).withConfig(cssConfig)`
  gap: ${({ gap }) => gap};
  flex: ${({ flex }) => flex};
  flex-flow: ${({ flexFlow }) => flexFlow};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  justify-items: ${({ justifyItems }) => justifyItems};

  ${media.md`
    align-items: ${({ alignItemsMd }) => alignItemsMd};
    flex-flow: ${({ flexFlowMd }) => flexFlowMd};
    gap: ${props => props.gapMd};
  `}

  ${media.sm`
    align-items: ${({ alignItemsSm }) => alignItemsSm};
    flex-flow: ${({ flexFlowSm }) => flexFlowSm};
    gap: ${props => props.gapSm};
  `}
`

Flex.defaultProps = {
  display: "flex",
  flexFlow: "column",
}

Flex.propTypes = {
  gapSm: PropTypes.string,
  gapMd: PropTypes.string,
  gap: PropTypes.string,

  columnsSm: PropTypes.string,
  columnsMd: PropTypes.string,
  columns: PropTypes.string,

  rowsSm: PropTypes.string,
  rowsMd: PropTypes.string,
  rows: PropTypes.string,

  flex: PropTypes.string,

  flexFlowSm: PropTypes.string,
  flexFlowMd: PropTypes.string,
  flexFlow: PropTypes.string,

  flexWrap: PropTypes.string,

  alignItemsSm: PropTypes.string,
  alignItemsMd: PropTypes.string,
  alignItems: PropTypes.string,

  justifyContent: PropTypes.string,
  justifyItems: PropTypes.string,
}

export default Flex
